import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ToolbarsComunicatorService {
  private activeToolsSubject = new BehaviorSubject<number>(null);

  public activeTools$ = this.activeToolsSubject.asObservable();

  private measurementMenuSubject = new BehaviorSubject<boolean>(false);

  public measurementMenuSubject$ = this.measurementMenuSubject.asObservable();

  allowTools: any = {};

  setActiveTool(toolId: number) {
    this.activeToolsSubject.next(toolId);
  }

  getActiveTool(): number {
    return this.activeToolsSubject.getValue();
  }

  changeToolStatus(status: boolean, mapId: number) {
    this.allowTools[mapId] = status;
    const isAllowActivateTools = this.checkOneMapIsEnabled(this.allowTools);
    this.measurementMenuSubject.next(isAllowActivateTools);
    if (!isAllowActivateTools) {
      this.activeToolsSubject.next(null);
    }
  }

  private checkOneMapIsEnabled(mapList: any): boolean {
    if (!mapList) {
      return false;
    }
    for (const mapId in mapList) {
      if (mapList.hasOwnProperty(mapId) && !mapList[mapId]) {
        return true;
      }
    }
    return false;
  }
}
